export default __webpack_public_path__ + "static/media/DT_BG.97067acb.png";